<script lang="ts">
  import IconButton, {
    type IconButtonSizes,
    type IconButtonVariants,
  } from "$components/+blocks/IconButton/IconButton.svelte";
  import type { IconType } from "$components/+blocks/OVIcon/OVIcon";

  export let size: IconButtonSizes = "medium"; // default size is small, but can be overridden with medium or large
  export let variant: IconButtonVariants = "tertiary"; // default variant is tertiary, but can be overridden with the other variants
  export let icon: IconType;
  export let a11yLabel: string; // provide a label describing the button e.g. "open menu", this is also used as the HTML title
  export let disabled: boolean = false;
  export let customIconSize: string | undefined = undefined;
  export let active: boolean;
</script>

<!-- in the Dropdown instance where this component is used, remember to specify slot="trigger" -->
<IconButton
  variant={active ? "active" : variant}
  {size}
  {icon}
  {a11yLabel}
  {disabled}
  {customIconSize}
/>
